interface CurrentLocationProps {
  handleUseCurrentLocation: (e: React.MouseEvent) => void;
  handleMouseOverSuggestions: (e: React.MouseEvent<HTMLElement>) => void;
  handleMouseLeaveSuggestions: (e: React.MouseEvent<HTMLElement>) => void;
  stopPropagation: (e: React.MouseEvent<HTMLElement>) => void;
  isFocused: boolean;
}

export const CurrentLocation = ({
  handleUseCurrentLocation,
  handleMouseOverSuggestions,
  handleMouseLeaveSuggestions,
  stopPropagation,
  isFocused,
}: CurrentLocationProps) => {
  return (
    <div
      style={{
        backgroundColor: isFocused ? '#f0f0f0' : 'white',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        padding: '10px 15px',
        marginTop: '5px',
        fontSize: '14px',
        cursor: 'pointer',
      }}
      onClick={handleUseCurrentLocation}
      onMouseOver={handleMouseOverSuggestions}
      onMouseLeave={handleMouseLeaveSuggestions}
      onDrag={stopPropagation}
      onDragCapture={stopPropagation}
      onDoubleClick={stopPropagation}
      onDoubleClickCapture={stopPropagation}
      onMouseMove={stopPropagation}
      tabIndex={0}
    >
      {/* TODO: Change to calcite geolocation icon */}
      <p style={{ margin: 0 }}>📍 Use current location</p>
    </div>
  );
};
